/**
 * One-shot, in-memory hand-off of the create-task draft from the modal to the full-page form.
 *
 * Used when the user transitions modal → full page (the "Open full page" link, or a resize to
 * mobile). Kept in a module variable rather than router/history state so moment dates, File
 * objects, and loaded option lists survive intact (same SPA session, no serialization).
 *
 * The draft is consumed (and cleared) exactly once by the full-page form on mount, so a later
 * direct visit to the form doesn't pick up a stale draft.
 */

let draft = null;

export const setTaskFormDraft = (value) => {
  draft = value;
};

export const consumeTaskFormDraft = () => {
  const value = draft;
  draft = null;
  return value;
};
